export const RouteUrls = {
  LOGOUT: 'logout',
  REDIRECT: 'redirect',
  NO_PERMISSION: 'no-permission',

  DASHBOARD: {
    MODULE_BASE: 'dashboard'
  },

  AUTHENTICATION: {
    MODULE_BASE: 'auth',
    LOGIN: 'login',
    SIGNUP: 'signup',
    FORGOT: 'forgot-password',
    CHANGE_PASSWORD: 'change-password',
    VERIFY_USER: 'verify-user',
    TWO_FACTOR: 'two-factor',
  },

  ACCOUNT_SETTINGS: {
    MODULE_BASE: 'account-settings',
    USERS: 'users',
    PERMISSION_MANAGER: 'permission-manager',
    LIMIT_REQUESTS: 'application-access-request',
    CHAT: 'chat',
    DASHBOARDS: 'dashboards',
    NL_TRAINING: 'ai-training'
  },

  ACCREDITATION: {
    MODULE_BASE: 'accreditation',
    CREATE_PROGRAM: 'not_implemented',
    CERTIFICATES: 'certificates/list',
    PIONEER_FACILITIES: 'pioneer-program/list'
  },

  APPLICATION: {
    MODULE_BASE: 'application',
    APPLY: 'apply',
    APPLY_PROGRAM: 'program',
    APPLY_RESET: 'reset',
    APPLY_INFO: 'facility',
    APPLY_LOCATION: 'location',
    EXTENSION_SITES: 'extension-sites',
    APPLY_PROGRAM_SPECIFIC: 'program-details',
    APPLY_FLOOR_PLAN: 'floor-plan',
    APPLY_FILES: 'files',
    APPLY_OWNERS: 'owners',
    DETAILS_MODULE: 'application',
    ACCREDITATION: 'accreditation',
    ACCREDITATION_LIST: 'list',
    ACCREDITATION_DETAILS: 'update',
    FACILITY: 'facility',
    SIGNATURE: 'signature',
    DISCOUNT: 'discount'
  },

  SURVEY: {
    MODULE_BASE: 'survey',
    SURVEY_MANAGEMENT: 'survey-management',
    SURVEYORS_MANAGEMENT: 'surveyors-management',
    SURVEYOR_DETAILS: 'surveyor-details',
    LANGUAGE_MANAGEMENT: 'standard-management',
    SURVEY_LANGUAGES: 'standards',
    PROGRAM_LANGUAGES: 'program-standards',
    SURVEY_OPTIONS: 'options',
    SECTIONS: 'sections',
    CHAPTERS: 'chapters',
    CONDITIONS_MANAGEMENT: 'conditions-management',
    REGULATORS: 'regulators',
    REGULATIONS: 'regulations',
    REGULATION_FORM: 'regulation-form',
    SURVEY_MERGE: 'merge',
    WORKSHEETS: 'worksheets'
  },
  FINANCIAL: {
    INVOICE: {
      MODULE_BASE: 'financial',
      LIST: 'invoices',
      INVOICING_LIST: 'invoicing',
      REVENUE_LIST: 'revenue',
      LATE_BILLING: 'late-billing',
      TERMINATIONS: 'terminations',
      CREATE: 'invoices/create',
      UPDATE: 'invoices/:id/update',
      FINANCE_FEE: 'fees'
    },
    FACILITIES_LIST: {
      MODULE_BASE: 'financial',
      LIST: 'customers',
    },
    PAYMENT: {
      MODULE_BASE: 'financial',
      LIST: 'payments',
      CHECKOUT: 'payment/:id/checkout',
      PAYMENT_CHECKOUT: 'payment/checkout'
    },
    SALE_ORDER: {
      MODULE_BASE: 'financial',
      LIST: 'estimates',
      CREATE: 'estimates/create',
      UPDATE: 'estimates/:id/update'
    },
    PRODUCT: {
      MODULE_BASE: 'financial',
      LIST: 'product'
    },
    DISCOUNT: {
      MODULE_BASE: 'financial',
      LIST: 'discount'
    },
    CLASS: {
      MODULE_BASE: 'financial',
      LIST: 'class'
    }
  },

  FACILITY_INFO: {
    MODULE_BASE: 'facility-information',
    UPDATE: 'update',
    APPLICATION: 'application',
    FACILITY: 'facility',
    FACILITY_LIST: 'facility',
    ADDITIONAL_SERVICES: 'additional-services',
    REQUEST: 'approval-request',
    NATIONAL_ACCOUNT: 'national-account',
    NOTES: 'notes'
  },

  INVESTIGATION: {
    MODULE_BASE: 'investigation',
    LIST_OPEN: 'list/open',
    LIST_CLOSED: 'list/closed',
    FORM: 'form'
  },

  EXTERNAL_REPORT: {
    EXTERNAL_REPORT: 'external-report',
    WASHINGTON_REPORT: 'washington-report',
    SOUTH_CAROLINA_REPORT: 'south-carolina',
    NEW_YORK_REPORT: 'new-york',
    CMS_MONTHLY: 'cms-monthly',
    CMS_FORECAST: 'cms-forecast',
    CMS_WEEKLY: 'cms-weekly',
    CMS_CUSTOM: 'cms-custom',
    ASSURE: 'assure',
    IQES: 'iqes',
    AGING: 'aging-report',
    COMPLETE_SURVEY: 'complete-report',
    DEFICIENCY_REPORT: 'deficiencies-program-report',
    DEFICIENCY_QUESTION_REPORT: 'deficiencies-question-report',
    REACTIVATED_SURVEYS: 'reactivated-surveys',
    ONSITE_TIME_IN_OUT: 'onsite-time-in-out',
    FACILITY_COUNTS: 'facility-counts',
    CARE_OBSERVATION: 'care-observation'
  },

  HISTORY: {
    MODULE_BASE: 'history'
  },
  NOTIFICATION: {
    LIST: 'notifications/list'
  }
};
